import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedMethods } from './components/FailedMethods';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
const META_PIXEL_ID = '1282459354102504';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!window.fbq) {
      ;
      (function (f: any, b: Document, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', META_PIXEL_ID);
    }
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-navy selection:bg-gold/30" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <OpeningHook data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <FailedMethods data-id="element-6" />
      <UniqueMechanism data-id="element-7" />
      <WhatYouGet data-id="element-8" />
      <WhoIsThisFor data-id="element-9" />
      <HowItWorks data-id="element-10" />
      <ProofSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <OfferSection data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}